import { WorkflowRectTypes } from '@helpers/Enums';
import { isFilledArray } from '@helpers/validation/arrayValidators';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import React, { Component } from 'react';
import { Arrow, Circle, Group, Layer, Rect, Stage, Text } from 'react-konva';
import uuid from 'uuidv4';

import ConnectionModeAlert from './ConnectionModeAlert';
import Tooltip from './Tooltip';
import WorkflowIconGenerator from './WorkflowIconGenerator';

const processIcon = require('./workflowAssets/process-icon.svg')
const createLineIcon = require('./workflowAssets/createLine.svg')
const notificationIcon = require('./workflowAssets/notification-icon.svg')
const brokenProcess = require('./workflowAssets/broken-process.svg')
const brokenNotification = require('./workflowAssets/broken-notification.svg')
const closeIcon = require('./workflowAssets/close-icon.svg')
const whiteCloseIcon = require('./workflowAssets/white-close-icon.svg')


interface stateType {
  rectangleWidth: number;
  rectangleHeight: number;
  distanceBetweenDiamond: number;
  diamondLength: number;
  diamondSide: number;
  distanceBetweenRects: number;
  initialPosition: {
    x: number,
    y: number
  };
  rects: any;
  mouseEnterEventCoordinates: {
    x: number,
    y: number,
  };
  currentRectId?: number;
  hoverIconsVisibility: boolean;
  brokenNodesIds: any[];
  biggestXVal?: {
    id: string;
    value: number;
  }
  shouldBiggestXValUpdate: boolean;
  nodesToConnect: {
    from?: string;
    to?: string;
  }
  shouldReceiveNextprops: boolean;
  connectionModeAlertVisibility: boolean
  connectionSideEffects : boolean;
}

interface propType {
  rectangleWidth: number;
  rectangleHeight: number;
  distanceBetweenRects: number;
  diamondLength: number;
  data: any;
  updateNodesArray: Function;
  openSideNav: Function;
  closeSideNav: Function;
  shouldUpdatedata: boolean;
  updatedData: Function;
  retrieveNodeState: Function;
  workflowValidator: Function;
  checkForBrokenWorkflow: boolean;
  workflowChecked: Function;
  toggleConditionsModalVisibility: Function;
}
export default class WorkflowCanvas extends Component<propType, stateType>{
  constructor(props: propType){
    super(props)

    this.state = {
      rectangleWidth: this.props.rectangleWidth,
      rectangleHeight: this.props.rectangleHeight,
      distanceBetweenRects: this.props.distanceBetweenRects,
      diamondLength: this.props.diamondLength,
      diamondSide: 80,
      distanceBetweenDiamond: 310,
      initialPosition: {
        x: 80,
        y: Math.floor(window.innerHeight / 3),
      },
      rects: [],
      mouseEnterEventCoordinates: {
        x: 0,
        y: 0
      },
      currentRectId: undefined,
      hoverIconsVisibility: false,
      brokenNodesIds: [],
      biggestXVal: undefined,
      shouldBiggestXValUpdate: false,
      nodesToConnect: {
        from: undefined,
        to: undefined
      },
      shouldReceiveNextprops: true,
      connectionModeAlertVisibility: false,
      connectionSideEffects: false
    }
  }
  
  UNSAFE_componentWillReceiveProps(nextProps: any){
    if(this.state.shouldReceiveNextprops || nextProps.shouldUpdatedata){
      this.setState({rects: nextProps.data, shouldReceiveNextprops: false})
      if(this.props.shouldUpdatedata) this.props.updatedData()
    }
    if(nextProps.checkForBrokenWorkflow){
      const { rects } = this.state
      const { workflowValidator, workflowChecked } = this.props
      let isWorkflowBroken = false
      for(let i = 0 ; i < rects.length; i++) {
        if(rects[i].type === WorkflowRectTypes.START || rects[i].type === WorkflowRectTypes.END){
          continue;
        }
        const isBroken = this.brokenWorkflowValidator(rects[i])
        if(isBroken){
          isWorkflowBroken = isBroken
        }
      }
      workflowValidator(isWorkflowBroken);
      workflowChecked();
    }
  }
  
  getNodeHeightDifference = (previousRect: any) =>{
    if(previousRect && previousRect.next && previousRect.next.length > 0){
      const heightDiff = 100;
      let mutipliedTimes
      if(previousRect.next.length % 2 !== 0){
        mutipliedTimes = previousRect.next.length > 1 ? Math.ceil(previousRect.next.length/2) : previousRect.next.length
      } else {
        mutipliedTimes = previousRect.next.length > 1 ? (previousRect.next.length/2) : previousRect.next.length - 1
        mutipliedTimes = - mutipliedTimes
      }
      const result = mutipliedTimes * heightDiff
      return result
    }
    return 0
  }
  
  getNodeInterface = (type: WorkflowRectTypes) => {
    let content, posX, posY;
    
    switch(type){
      case WorkflowRectTypes.PROCESS:
        content = I18n.l('labels.processTitle');
        [posX, posY] = [35, 10]
        break;
      case WorkflowRectTypes.NOTIFICATION:
        content = I18n.l('labels.notification');
        [posX, posY] = [35, 10]
        break;
      case WorkflowRectTypes.CONDITION:
        content = I18n.l('process.conditionTitle');
        [posX, posY] = [-37, 50]
        break;
    }
    const interfaceObj = {
      label: {
        text: content,
        posX,
        posY
      }
    }

    return interfaceObj
  }
  
  
  createPolygonStructure = async (type: WorkflowRectTypes) => {
    const { rects, initialPosition, currentRectId, biggestXVal } = this.state;
    let breadth;
    const id = uuid();
    let x,y,previousRect,nodeConnected;
    let yHeightValue = 0;
    if(rects.length > 0 && currentRectId !== undefined){
      const currentPolygon: any = rects.find((polygon: any) => polygon.id === currentRectId)
      x = currentPolygon.x
      y = currentPolygon.y
      previousRect = rects.find((polygon: any) => polygon.id === currentRectId)
      const beginPolygon: any = rects.find((polygon: any) => polygon.id === "start")
      
      if(beginPolygon.next && beginPolygon.next.length === 1 && previousRect.id === "start"){
        NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.error.nodes.begin'))
        return
      }
      if(previousRect){
        if(previousRect.next){
          yHeightValue = this.getNodeHeightDifference(previousRect)
        }
        if(previousRect.type !== WorkflowRectTypes.START){
          breadth = previousRect.breadth + 1
        } else {
          breadth = 0
        }
      } else {
        breadth = 0
      }
      if(type === WorkflowRectTypes.CONDITION){
        if(previousRect.next && previousRect.next.length >0 ){
        for(let nextNode of previousRect.next){
          nodeConnected = rects.find((polygon: any) => polygon.id === nextNode );
          if(nodeConnected){
            return
          }
 
          }
        }
      }
      //this Math.floor serves the purpose of making sure there aren't any
      //polygons located in floating point positions like x:277,3
      //when that happens the lines look all blury and weird
      const line = this.createLineBasedOnType({type, x, y, yHeightValue, previousType: previousRect.type, toId: id})
      
      if(!previousRect.line) previousRect.line = []
      previousRect.line.push(line)

      if(previousRect.next){
        const nextIndexes = previousRect.next
        nextIndexes.push(id);
      } else { previousRect.next = [id] }

    } else {
      [x,y] = [initialPosition.x, initialPosition.y - 40];
    }
   
    const newPolygon = this.createPolygonDraw({
      x,
      y,
      type,
      yHeightValue,
      from: [currentRectId] || '', 
      previousType: previousRect ? previousRect.type : undefined,
      id,
      breadth})

      if(!biggestXVal || biggestXVal && newPolygon.x > biggestXVal.value){
        this.setState({biggestXVal: {id: newPolygon.id, value: newPolygon.x}})
      }

      if(type === WorkflowRectTypes.CONDITION){
        newPolygon.rotation = 45
      }
    const polygonInterface = this.getNodeInterface(type)

    const finalPolygon = Object.assign({}, newPolygon, polygonInterface)
    
    this.checkWorkflowFix()

    rects.push(finalPolygon);
    this.setState({ rects })
    this.props.updateNodesArray(rects)
      
  }


  checkWorkflowFix = () => {
    const { brokenNodesIds, rects } = this.state
    //validate if some of the broken nodes are now fixed
    if(brokenNodesIds && brokenNodesIds.length > 0){
      for(let i = 0; i < brokenNodesIds.length; i++){
        const actualNode = rects.find((node: any) => node.id === brokenNodesIds[i])
        
        const properlyConnected = actualNode.from && actualNode.next && actualNode.next.length > 0;
        let filled = false
        if(actualNode.type === WorkflowRectTypes.PROCESS && actualNode.process){
          filled = true
        }
        if(actualNode.type === WorkflowRectTypes.NOTIFICATION && actualNode.notification){
          filled = true
        }
        if(properlyConnected && filled){
          this.regularWorkflowStyler(actualNode)
          brokenNodesIds.filter((id: string) => id !== actualNode.id)
        }
      }
    }
  }

  createPolygonDraw = (
    {x,y,type, yHeightValue, from, previousType, id, breadth}: {x: number, y: number, type: WorkflowRectTypes, yHeightValue: number, from: string[], previousType: WorkflowRectTypes, id: string, breadth: number}) => {    
      const createdRect: {
      id: string,
      x: number, 
      y: number, 
      color: string,
      fillColor?: string, 
      fontColor?: string,
      from: string[],
      rotation?: number,
      type: WorkflowRectTypes,
      breadth: number,
      close: {posX: number, posY: number},
      newLineIcon: {posX: number, posY: number},
      icon?: {posX: number, posY: number}
      } = {
      id,
      x: 0,
      y: 0,
      color: '',
      from,
      type,
      breadth
    }
    if(previousType && previousType === WorkflowRectTypes.CONDITION) y += 16
    if(previousType && previousType === WorkflowRectTypes.START) y -= 40
    const { distanceBetweenRects, distanceBetweenDiamond } = this.state
    if(type === WorkflowRectTypes.CONDITION){
      createdRect.x = x + distanceBetweenDiamond;
      createdRect.y = y + yHeightValue - 16;
      createdRect.color = '#53BFC9';
      createdRect.fillColor = '#53BFC9';
      createdRect.fontColor = '#FFF';
      createdRect.close = {posX: 10, posY: 5};
      createdRect.newLineIcon = {posX: 40, posY: 15};
    } else {
      createdRect.x = x + distanceBetweenRects;
      createdRect.y = y + yHeightValue;
      createdRect.color = type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
      createdRect.fontColor = type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
      createdRect.icon = {posX: 5, posY: 5};
      createdRect.close = {posX: 140, posY: 1};
      createdRect.newLineIcon = {posX: 150, posY: 8};
    }
    
    return createdRect;
  }
  
  createLineBasedOnType = (
    {type, x, y, yHeightValue, previousType, toId, toNode}: {type: WorkflowRectTypes, x: number, y: number, yHeightValue: number, previousType: number, toId: string, toNode?: any}
    ) => {
      //I would like to just let this unassigned, but typescript made me initialize the object
    let line: {fromX: number, fromY: number, toX: number, toY: number, toId: string} = {
      fromX: 0,
      fromY: 0,
      toX: 0,
      toY: 0,
      toId
    };
    const {rectangleWidth, rectangleHeight, distanceBetweenRects, diamondLength} = this.state
    
    if(previousType === WorkflowRectTypes.NOTIFICATION || previousType === WorkflowRectTypes.PROCESS){
      line.fromX = Math.floor(x + (rectangleWidth + 5))
      line.fromY = Math.floor(y + (rectangleHeight / 2))
    } else if(previousType === WorkflowRectTypes.CONDITION){
      line.fromX = Math.floor(x + (diamondLength - 55))
      line.fromY = Math.floor(y + (rectangleHeight / 2) + 16)
    } else if (previousType === WorkflowRectTypes.START){
      line.fromX = Math.floor(x + 45)
      line.fromY = Math.floor(y)
    }
    if(previousType === WorkflowRectTypes.CONDITION) y += 16
    if(previousType === WorkflowRectTypes.START) y -= 40


    if(toNode){
        if(toNode.type === WorkflowRectTypes.END){
          line.toX = Math.floor(toNode.x - 50)
          line.toY = Math.floor(toNode.y)
        }
        else {
          line.toX = Math.floor(toNode.x - 5)
          line.toY = Math.floor(toNode.y + (rectangleHeight / 2))
        }
    } else {
      if (type === WorkflowRectTypes.NOTIFICATION || type === WorkflowRectTypes.PROCESS){
        line.toX = Math.floor(x +  distanceBetweenRects - 5),
        line.toY = Math.floor(y + yHeightValue + (rectangleHeight / 2))
      } else if(type === WorkflowRectTypes.CONDITION) {
        //change this to something that works for the diamond
        line.toX = Math.floor(x +  distanceBetweenRects - 5),
        line.toY = Math.floor(y + yHeightValue + (rectangleHeight / 2))
      }
    }
    return line
  }
  

  handleMove = async (evt: any, id: string) => {
    const { rects, rectangleHeight, rectangleWidth, diamondLength, biggestXVal } = this.state;
    const currentX = Math.floor(evt.target.attrs.x);
    const currentY = Math.floor(evt.target.attrs.y);

    if(biggestXVal && currentX > biggestXVal.value){
      this.setState({biggestXVal: {id, value: currentX}})
    }
    if(biggestXVal && id === biggestXVal.id){
      if(currentX < biggestXVal.value){
        this.setState({shouldBiggestXValUpdate: true})
      }
    }

    const currentRect = rects.find((polygon: any) => polygon.id === id)
    currentRect.x = currentX
    currentRect.y = currentY
    //a edição do from é feita no retângulo atual
    if(currentRect.next){
      for(let line of currentRect.line){
        if(currentRect.type === WorkflowRectTypes.CONDITION){
          line.fromX = currentX + (diamondLength/2) + 5;
          line.fromY = currentY + (rectangleHeight/2) + 16;
        } else {
          line.fromX = currentX + rectangleWidth + 5;
          line.fromY = currentY + (rectangleHeight/2)
        }
      }
    }
   
    // a edição do to é feita nos retângulos anteriores
    for(let box of rects){
      if(box.next && box.next.includes(id)){
        const idx = box.next.findIndex((e: any) => e === id);
        //doesn't need math floor since current x already is a int and a int - a int will always be a int
        if(currentRect.type === WorkflowRectTypes.CONDITION){
          box.line[idx].toX = currentX - (diamondLength/2) - 5
          box.line[idx].toY = Math.floor(currentY + (rectangleHeight/2) + 16)
        } else if(currentRect.type === WorkflowRectTypes.END) {
          box.line[idx].toX = currentX - 40
          box.line[idx].toY = Math.floor(currentY)
        }
        else {
          box.line[idx].toX = currentX - 5
          box.line[idx].toY = Math.floor(currentY + (rectangleHeight/2))
        }
      }
    }
   

    const rectCoordinates = {
      x: currentX - 60,
      y: currentY - 60
    }
    
    this.setState({ rects, mouseEnterEventCoordinates : rectCoordinates })
    
  }

  renderTooltip = async (evt: any, id: number) => {
    const { rects } = this.state
    const actualNode = rects.find((polygon: any) => polygon.id === id)
    if(evt.target.attrs && evt.target.attrs.image){
      return
    }
    if(actualNode.type === WorkflowRectTypes.END){
      return 
    }

    const absolutePositions = evt.target.getAbsolutePosition()
    let {x, y} = absolutePositions

    if(actualNode.type === WorkflowRectTypes.CONDITION) x -= 80
    else if (actualNode.type === WorkflowRectTypes.PROCESS || actualNode.type === WorkflowRectTypes.NOTIFICATION) {
      x -= 60
    }
    else if (actualNode.type === WorkflowRectTypes.START){
      x -= 120
      y -= 30
    }

    y -= 60

    const rectCoordinates = {
      x,
      y
    }
    
    this.setState({mouseEnterEventCoordinates : rectCoordinates, currentRectId: id, hoverIconsVisibility: true})
  }

  brokenWorkflowValidator = (node: any) => {
    let brokenWorkflow: any = {};
    if(!isFilledArray(node.from)){
      node.breadth = undefined
    }
    if(!isFilledArray(node.next) ||
       !isFilledArray(node.from) ||
       node.type === WorkflowRectTypes.NOTIFICATION && !node.notification ||
       node.type === WorkflowRectTypes.PROCESS && !node.process){

      let { brokenNodesIds } = this.state
      brokenNodesIds = Array.isArray(brokenNodesIds) ? brokenNodesIds : [];

        brokenNodesIds.push(node.id) 
        if(!isFilledArray(node.from) || !isFilledArray(node.next)) {
          if(!node.broken) node.broken = {}  
          node.broken.connectionError = true;
          brokenWorkflow.connectionError = true;
        }

        if(node.type === WorkflowRectTypes.NOTIFICATION && !node.notification || node.type === WorkflowRectTypes.PROCESS && !node.process){
          if(!node.broken) node.broken = {}
          node.broken.unfilled = true;
          brokenWorkflow.unfilledNodes = true 
        }

        this.brokenWorkflowStyler(node);
        this.setState({brokenNodesIds});
    } else if(node.type === WorkflowRectTypes.CONDITION){
      let { brokenNodesIds } = this.state
      brokenNodesIds = Array.isArray(brokenNodesIds) ? brokenNodesIds : [];
      if(!node.conditions){
        if(!node.broken) node.broken = {}
        node.broken.unfilled = true;
        brokenWorkflow.conditionless = true;
        this.brokenWorkflowStyler(node);
      }
      if(node.conditions){
        for(let condition of node.conditions){
          if(!condition.id || !condition.next || !condition.operation){
            this.brokenWorkflowStyler(node);
            if(!node.broken) node.broken = {}
            node.broken.unfilledConditions = true;
            brokenWorkflow.conditionless = true;
            break;
          }
        }
      }
      this.setState({brokenNodesIds});
    }
    else {
      if(node.type !== WorkflowRectTypes.CONDITION){
        if(node.fillColor){
          this.regularWorkflowStyler(node)
        } 
      }
    }
    if(Object.keys(brokenWorkflow).length === 0){
      brokenWorkflow = false
    }
    return brokenWorkflow 
  }

  brokenWorkflowStyler = (node: any) => {
    node.color = '#FA8383'
    node.fontColor = '#ffffff'
    node.fillColor = '#FA8383'
  }

  regularWorkflowStyler = (node: any) => {
    let { brokenNodesIds } = this.state
    brokenNodesIds = brokenNodesIds.filter((stringNode: string) => stringNode !== node.id)
    if(node.type !== WorkflowRectTypes.CONDITION){
      delete node.fillColor
      node.color = node.type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
      node.fontColor = node.type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
    } else {    
      node.color = '#53BFC9'
      node.fillColor = '#53BFC9'
    }
    delete node.broken
    this.setState({brokenNodesIds})
  }


  deleteNode = async (id: string) => {
    const { rects, brokenNodesIds, biggestXVal } = this.state
    const filteredRects = rects.filter((rect: any) => rect.id !== id)
    if(brokenNodesIds && brokenNodesIds.length > 0){
      const isBroken = brokenNodesIds.indexOf(id)
      if(isBroken !== -1){
        brokenNodesIds.splice(isBroken)
      }
    }

    for(let i = 0; i < filteredRects.length; i++){
      if(filteredRects[i].next && filteredRects[i].next.includes(id)){
        if(filteredRects[i].line) filteredRects[i].line = filteredRects[i].line.filter((line: any) => line.toId !== id)
        filteredRects[i].next = filteredRects[i].next.filter((nextId: string) => nextId !== id)
        if(filteredRects[i].next.length === 0) delete filteredRects[i].next
      }
      if(filteredRects[i].from && Array.isArray(filteredRects[i].from) && filteredRects[i].from.includes(id)) {
        filteredRects[i].from = filteredRects[i].from.filter((fromId: string) => fromId !== id)
      }
      this.brokenWorkflowValidator(filteredRects[i])
    }
    
    let shouldUpdate = false
    if(biggestXVal && id === biggestXVal.id){
      shouldUpdate = true
    }
    
    this.setState({rects: filteredRects, hoverIconsVisibility: false, shouldBiggestXValUpdate: shouldUpdate})
    this.getLastXPosition()

    this.props.updateNodesArray(rects, id)
  }


  rectOrCircle = (node: any) => {
    const {diamondSide, rectangleHeight, rectangleWidth } = this.state
    if(node.type === WorkflowRectTypes.START || node.type === WorkflowRectTypes.END){
      const color = node.type === WorkflowRectTypes.START ? '#138A75' : '#8A1313'
      return (
        <Circle
        radius={40}
        fill={color}
        onClick={() => this.connectNodes(node)}
        /> 
      )
    } else return(
      <Rect 
          width={node.type === WorkflowRectTypes.CONDITION ? diamondSide : rectangleWidth}
          height={node.type === WorkflowRectTypes.CONDITION ? diamondSide : rectangleHeight}
          stroke={node.color}
          fill={node.fillColor ? node.fillColor : '#ffffff'}
          rotation={node.rotation}
          cornerRadius={5}
          onClick={() => this.connectNodes(node)}
      />
    )
  }
  
  
  getLastXPosition = () => {
    const { shouldBiggestXValUpdate, biggestXVal, rects } = this.state
    
    if(shouldBiggestXValUpdate){
      if(rects && rects.length > 2){
        //length must be bigger than 2 because there are always a start node and a end node
        let newBiggestXVal = rects.find((e: any) => e.type !== WorkflowRectTypes.END && e.type !== WorkflowRectTypes.START)
        newBiggestXVal = {id: newBiggestXVal.id, value: newBiggestXVal.x}
        for(let i = 0; i < rects.length; i++){
          if(rects[i].type === WorkflowRectTypes.START || rects[i].type === WorkflowRectTypes.END || biggestXVal && rects[i].id === biggestXVal.id){
            continue;
          }
          if(rects[i].x > newBiggestXVal.value){
            newBiggestXVal = {id: rects[i].id, value: rects[i].x}
          }
        }
        this.setState({biggestXVal: newBiggestXVal, shouldBiggestXValUpdate: false})
      }
    }
  }
  
  breadthFixer = (fromNode: any, toNode: any) => {
   if(fromNode.breadth + 1 > toNode.breadth || !toNode.breadth){
     const nextBreadth = fromNode.breadth + 1;
     toNode.breadth = nextBreadth;
     
     if(isFilledArray(toNode.next)){
        for(let nextNodeId of toNode.next){
          if(nextNodeId === 'end') continue;
          const { rects } = this.state;
          const nextNode = rects.find((node: any) => node.id === nextNodeId);
          this.breadthFixer(toNode, nextNode);
        }
     }

   }
  }


  connectNodes = async (node: any, iconClicked?: boolean) => {
    const { nodesToConnect, rects } = this.state
    const nodeId = node.id
    let lineAlreadyExists = false;
    let rect;

    for(rect of rects){ 
      if(rect.from && rect.from.includes("start") && rect.type == WorkflowRectTypes.PROCESS && rect.breadth != 0){
        let rectReturned = this.formatBeginConnectedNodes(rect);
        rect = rectReturned;
      }
    }
    if(!nodesToConnect.from && iconClicked){
      const fromNodes = {
        from: nodeId,
        to: undefined
      }
      this.setState({nodesToConnect: fromNodes, hoverIconsVisibility: false, connectionModeAlertVisibility: true, connectionSideEffects: true})
      this.changeCursosOnLeave()
    }
    if(nodesToConnect.from && !nodesToConnect.to){
      if(nodeId !== nodesToConnect.from){
        const toNodes = {
          from: nodesToConnect.from,
          to: nodeId
        }
        const fromNode = rects.findIndex(e => e.id === toNodes.from)
        const toNode = rects.findIndex(e => e.id === toNodes.to)

        if(rects[fromNode].line && rects[fromNode].line.length > 0){
          for(let i = 0; i < rects[fromNode].line.length; i++){
            if(rects[fromNode].line[i].toId === nodeId){
              lineAlreadyExists = true;
              break;
            }
          }
        }
        if(lineAlreadyExists){
          NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.connection.duplicated.connection'))
          this.setState({nodesToConnect: {from: undefined, to: undefined}, connectionModeAlertVisibility: false})
        } else if(rects[fromNode].type === WorkflowRectTypes.START && rects[toNode].type === WorkflowRectTypes.END){
          NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.connection.start.to.end'))
          this.setState({nodesToConnect: {from: undefined, to: undefined}, connectionModeAlertVisibility: false})
        } else if (rects[fromNode].breadth >= rects[toNode].breadth || rects[toNode].type === WorkflowRectTypes.START){
          NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.connection.minor.breadth'))
          this.setState({nodesToConnect: {from: undefined, to: undefined}, connectionModeAlertVisibility: false})
        }
         else {
        
        if(!rects[toNode].breadth){
          this.breadthFixer(rects[fromNode], rects[toNode])
        }


        this.setState({nodesToConnect: toNodes})

        const lineCreationObject = {
          type: rects[fromNode].type,
          x: rects[fromNode].x,
          y: rects[fromNode].y,
          yHeightValue: 0,
          previousType: rects[fromNode].type,
          toId: rects[toNode].id,
          toNode: rects[toNode]
        }
  
        const createdLine = this.createLineBasedOnType(lineCreationObject)
        
        if(rects[fromNode].line && rects[fromNode].line.length > 0){
          rects[fromNode].line.push(createdLine)
        } else {
          rects[fromNode].line = [createdLine]
        }
        
        if(rects[fromNode].next && rects[fromNode].next.length > 0){
          if(!rects[fromNode].next.includes(rects[toNode].id)){
            rects[fromNode].next.push(rects[toNode].id)
          }
        } else {
          rects[fromNode].next = [rects[toNode].id]
        }
        
  
        if(rects[toNode].from && Array.isArray(rects[toNode].from)){
          const originalToNodeFrom = rects[toNode].from
          originalToNodeFrom.push(rects[fromNode].id)
          rects[toNode].from = originalToNodeFrom
        } else {
          rects[toNode].from = [rects[fromNode].id]
        }
      
        this.setState({nodesToConnect: {from: undefined, to: undefined}, rects, hoverIconsVisibility: false, connectionModeAlertVisibility: false})
        this.checkWorkflowFix()
        this.props.updateNodesArray(rects)
        }
      } else if(nodeId === nodesToConnect.from) {
        NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.connection.same.node.error'))
        this.setState({nodesToConnect: {from: undefined, to: undefined}, connectionModeAlertVisibility: false})
      }
    }

  }


  formatBeginConnectedNodes = (rect: any) => {
    delete rect.afterTime;
    delete rect.group;
    rect.breadth = 0;
    return rect;
  }

  changeCursorOnEnter = () => {
    document.documentElement.style.cursor = 'pointer'
  }
  changeCursosOnLeave = () => {
    document.documentElement.style.cursor = 'default'
  }

  passNodeArrayToProps = () => {
    const { rects } = this.state
    this.props.updateNodesArray(rects)
  }

  handleSidenavVisibility = (node: any) => {
    if(this.state.connectionSideEffects){
      this.setState({connectionSideEffects: false})
    } else {
      this.props.retrieveNodeState(node)
      const { nodesToConnect } = this.state
      if(!nodesToConnect.from && node.type !== WorkflowRectTypes.START && node.type !== WorkflowRectTypes.END && node.type !== WorkflowRectTypes.CONDITION){
        this.props.openSideNav(node)
      }
      if(!nodesToConnect.from && node.type === WorkflowRectTypes.CONDITION){
        this.props.toggleConditionsModalVisibility(node)
      }
    }
  }
  
  render() {
    const { rects, mouseEnterEventCoordinates, hoverIconsVisibility, currentRectId, connectionModeAlertVisibility } = this.state
    if(this.props.loading){
      return (
        <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <h1>{I18n.l('common.loadingData')}</h1>
        </div>
      )
    }
    return (
      <div style={{position: 'relative', overflow: 'hidden', backgroundColor: '#F3FAFF',height: '100%'}}>
        <ConnectionModeAlert 
        visible={connectionModeAlertVisibility}
        onCancel={() => this.setState({nodesToConnect: {from: undefined, to: undefined}, connectionModeAlertVisibility: false})}/>
        <div style={{position: 'absolute', left: mouseEnterEventCoordinates.x, top: mouseEnterEventCoordinates.y, zIndex: 4}}>
          <Tooltip visible={hoverIconsVisibility}>
            <button onClick={() => this.createPolygonStructure(WorkflowRectTypes.PROCESS)} className="left-button">{I18n.l('labels.processTitle')}</button>
            <button onClick={() => this.createPolygonStructure(WorkflowRectTypes.NOTIFICATION)}>{I18n.l('labels.notification')}</button>
            <button onClick={() => this.createPolygonStructure(WorkflowRectTypes.CONDITION)} className="right-button">{I18n.l('label.pages.path.conditions')}</button>
          </Tooltip >
        </div>
        <Stage 
        width={window.innerWidth} 
        height={window.innerHeight} 
        draggable={true}
        onDragStart={() => this.setState({hoverIconsVisibility: false})}
        onDragEnd={this.getLastXPosition}>
        <Layer
        width={window.innerWidth}
        height={window.innerHeight}
        > 
        {rects.length > 0 &&
        rects.map((node: any) => 
        <React.Fragment key={node.id}>
        <Group 
          x={node.x}
          y={node.y}
          onClick={() => this.handleSidenavVisibility(node)}
          onMouseEnter={(evt: any) => this.renderTooltip(evt, node.id)}
          draggable={node.type === WorkflowRectTypes.START ? false : true}
          onDragMove={(evt: any) => this.handleMove(evt, node.id)}
          onDragEnd={this.passNodeArrayToProps}
        >
        {this.rectOrCircle(node)}
        {node.label && <Text
          x={node.label.posX}
          y={node.label.posY}
          text={node.label.text}
          fill={node.fontColor}
          onClick={() => this.connectNodes(node)}
          fontFamily={'Poppins'}
          fontSize={node.type === WorkflowRectTypes.NOTIFICATION ? 14 : 16}
        />}
        {node.icon && !node.broken &&
        <WorkflowIconGenerator 
          image={node.type === WorkflowRectTypes.NOTIFICATION ? notificationIcon : processIcon}
          x={node.icon.posX}
          y={node.icon.posY}
        />
        }
        {node.icon && node.broken &&
        <WorkflowIconGenerator 
          image={node.type === WorkflowRectTypes.NOTIFICATION || node.broken ? brokenNotification : brokenProcess}
          x={node.icon.posX}
          y={node.icon.posY}
        />
        }
        {node.close && 
        <WorkflowIconGenerator 
        image={node.type === WorkflowRectTypes.CONDITION || node.broken ? whiteCloseIcon : closeIcon}
        x={node.close.posX}
        y={node.close.posY}
        rotation={90}
        onClick={() => this.deleteNode(node.id)}
      />}
      {
      currentRectId === node.id && 
      hoverIconsVisibility && 
      node.type !== WorkflowRectTypes.END &&
      <WorkflowIconGenerator
        image={createLineIcon}
        x={node.newLineIcon && node.newLineIcon.posX}
        y={node.newLineIcon && node.newLineIcon.posY}
        height={30}
        width={30}
        onClick={() => this.connectNodes(node, true)}
        onMouseEnter={this.changeCursorOnEnter}
        onMouseLeave={this.changeCursosOnLeave}
      />
      }
      {
        node.process && 
        <Text
          x={node.process.name.length < 8 ? 40 : 5}
          y={40}
          text={node.process.name.length > 14 ? `${node.process.name.substr(0,13)}...` : node.process.name}
          onClick={() => this.connectNodes(node)}
          fontFamily={'Poppins'}
          fontSize={16}
          fill={node.broken ? '#ffffff' : '#84A1AA'}
          ellipsis={true}
        />
      }
      {
        node.notification && 
        <Text
          x={node.notification.title.length < 8 ? 40 : 5}
          y={40}
          text={node.notification.title.length > 14 ? `${node.notification.title.substr(0,13)}...` : node.notification.title}
          fontFamily={'Poppins'}
          fontSize={16}
          fill={node.broken ? '#ffffff' : '#84A1AA'}
          ellipsis={true}
        />
      }
        </Group>
        {node.line && node.line.map( (arrow: any, index: number) => <Arrow
            key={`${arrow.fromX}${arrow.toX}${arrow.fromY}${arrow.toY}-${index}`}
            points={[arrow.fromX, arrow.fromY, arrow.toX, arrow.toY]}
            fill={'#84A1AA'}
            stroke={'#84A1AA'} /> )}
        </React.Fragment>)}
        </Layer>
      </Stage>
      </div>
    )
  }
}
